import { Injectable } from "@angular/core";

import { ListItem } from "digital-core";

@Injectable()
export class BrowserValidatorService {

    /**
      This method will return true 
      if browser is matched with not supported browsers list
    */
    isBrowserNotSupported(notSupportedBrowsers: ListItem[]): boolean {
        if(notSupportedBrowsers && notSupportedBrowsers.length){
            for (let item of notSupportedBrowsers) {
                if(new RegExp(item.Value).test(window.navigator.userAgent.toLowerCase())){
                    return true;
                }
            }
        }
        return false;
    }

}